import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Figure, Tab, Tabs } from 'react-bootstrap';
import MainElectricalDisconnect from '../assets/safety/2.5-main-disconnect.png';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

// 2.14 ENERGY SOURCES
// 2.14.1 PDP Main Power Disconnect
// 2.14.2 PLC and Lighting Disconnect
// 2.14.3 Robot Controller Lockout
// 2.14.4 Main Air Lockout
// 2.14.5 Station and Robot Air Lockouts

const SIEnergySources = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety</Breadcrumb.Item>
							<Breadcrumb.Item active>Energy Sources</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="PDP Main Power Disconnect" className="mb-3">
								<Tab eventKey="PDP Main Power Disconnect" title="PDP Main Power Disconnect">
									<h2>PDP Main Power Disconnect</h2>
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<p>
												On the main power distribution panel (<b>PDP</b>), open the main electrical disconnect switch following the proper lockout /tagout procedures, including arc flash safety, and apply personal lock. If more than one person is to perform work on the machine, each employee is to place a personal lock on the energy source using a multiple lockout device (scissor lock). The main electrical disconnect will shut off the main power to the zone. Verify power is removed by indication on the <b>HMI</b> screen and attempting to start the machine.
											</p>
										</div>
										<div class="right-side">
											<figure>
												<img src={MainElectricalDisconnect} alt="Main Electrical Disconnect" style={{ width: '95vh' }} />
												<figcaption>Figure 1: Main Electrical Disconnect</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIEnergySources;
